import { IconProps } from "models"
import { ICON_DEFAULT_SIZE } from "utils/constants"

const EditIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	size = ICON_DEFAULT_SIZE,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 512 512"
			className={className}
			style={style}
			aria-hidden="true"
		>
			<path
				fill={color}
				d="M496.063 62.299l-46.396-46.4c-21.199-21.199-55.689-21.198-76.888 0L27.591 361.113c-2.17 2.17-3.624 5.054-4.142 7.875L.251 494.268a15.002 15.002 0 0017.48 17.482L143 488.549c2.895-.54 5.741-2.008 7.875-4.143l345.188-345.214c21.248-21.248 21.251-55.642 0-76.893zM33.721 478.276l14.033-75.784 61.746 61.75-75.779 14.034zm106.548-25.691L59.41 371.721 354.62 76.488l80.859 80.865-295.21 295.232zM474.85 117.979l-18.159 18.161-80.859-80.865 18.159-18.161c9.501-9.502 24.96-9.503 34.463 0l46.396 46.4c9.525 9.525 9.525 24.939 0 34.465z"
			/>
		</svg>
	)
}

export default EditIcon
